"use strict";

import * as Sentry from '@sentry/browser';
import { CaptureConsole } from '@sentry/integrations';

if (typeof AndApp === 'object') {
  AndApp.Sentry = {};
  AndApp.Sentry.init = (jsTrackingConfigPath) => {
    Sentry.init({
        dsn: jsTrackingConfigPath,
        ignoreErrors: [
          "Cannot read property 'createTimeline' of undefined",
          "TypeError: Cannot read property 'createTimeline' of undefined",
          "FB.NativeExtensions.onready only works when the page is rendered in a WebView of the native Facebook app. Test if this is the case calling FB.UA.nativeApp()",
          "Non-Error exception captured with keys: error",
          "Non-Error promise rejection captured with keys: error",
          "Non-Error promise rejection captured with value: -90581",
          "Non-Error promise rejection captured with value: undefined",
          "Non-Error promise rejection captured with value: -90580",
          "Non-Error promise rejection captured with value: -10105",
          "Non-Error promise rejection captured with value: -1",
          "Error: This Timeline type is no longer supported (Likes, Collections, & Moments).",
        ],
        integrations: [
          new CaptureConsole({levels: ['error']})
        ]
      })
  };
}
